<template>
  <div class="company-search">
    <el-input v-bind="$attrs" :value="value" :disabled="disabled" @input="onInput"
      @focus="onFocus" @blur="onBlur" />
    <div v-if="focused && !disabled" class="company-results">
      <button v-for="name in names" :key="name" type="button" @mousedown.prevent @click="select(name)">{{ name }}</button>
      <p v-if="hint" role="status">{{ hint }}</p>
    </div>
  </div>
</template>
<script>
import { searchInstitutionCompanies } from '@/api'
export default {
  name: 'CompanyNameInput',
  inheritAttrs: false,
  props: { value: { type: String, default: '' }, disabled: Boolean, english: Boolean },
  data() { return { names: [], focused: false, state: '', timer: null, blurTimer: null, sequence: 0 } },
  computed: {
    hint() {
      const messages = this.english
        ? { loading: 'Searching…', empty: 'No matches. You can enter the full name manually.', error: 'Search unavailable. Please enter the full name manually.', long: 'Use up to 32 characters to search, or enter the full name manually.' }
        : { loading: '正在搜索…', empty: '未找到匹配企业，可手动填写完整名称', error: '搜索暂不可用，请手动填写完整名称', long: '搜索关键词最多32个字，也可直接填写完整名称' }
      return messages[this.state] || ''
    }
  },
  watch: { disabled() { this.clear() }, english() { this.clear() } },
  beforeDestroy() { this.clear(); clearTimeout(this.blurTimer) },
  methods: {
    clear() { clearTimeout(this.timer); this.sequence++; this.names = []; this.state = '' },
    onInput(value) {
      this.$emit('input', value)
      this.clear()
      const keyword = value.trim()
      if (this.disabled || [...keyword].length < 2) return
      if ([...keyword].length > 32) { this.state = 'long'; return }
      const current = this.sequence
      this.state = 'loading'
      this.timer = setTimeout(async () => {
        try {
          const response = await searchInstitutionCompanies(keyword, this.english)
          if (current !== this.sequence || this.disabled) return
          const result = response && response.code === 200 && response.data
          this.names = result && result.available ? result.names || [] : []
          this.state = !result || !result.available ? 'error' : this.names.length ? '' : 'empty'
        } catch (e) { if (current === this.sequence) this.state = 'error' }
      }, 400)
    },
    select(name) { this.clear(); this.$emit('input', name); this.focused = false },
    onFocus() { clearTimeout(this.blurTimer); this.focused = true },
    onBlur() { this.blurTimer = setTimeout(() => { this.focused = false; this.clear() }, 200) }
  }
}
</script>
<style scoped>
.company-search { width: 100%; }
.company-results button { display: block; width: 100%; border: 0; border-bottom: 1px solid #eee; background: #fff; padding: 10px 12px; text-align: left; color: #333; font-size: 14px; line-height: 1.5; cursor: pointer; }
.company-results button:focus, .company-results button:hover { background: #fff6ef; }
.company-results p { margin: 0; padding: 5px 12px; font-size: 12px; line-height: 1.5; color: #888; }
</style>
